/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable jsx-a11y/anchor-is-valid */
import { Dispatch } from 'redux';
import { addDays } from 'date-fns';
import { Button, Collapse, notification } from 'antd';
import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { MinusOutlined, PlusOutlined } from '@ant-design/icons';
import { NavigateFunction, useNavigate } from 'react-router-dom';

import { title } from '../../../../utils/matchingTitle';
import { hourScheduleItems } from '../../../../utils/hourScheduleItems';
import { hourArrayItemsForBooking } from '../../../../utils/hourArrayItems';
import { alertFail, alertSuccess, convertMoney, setLocalStorage } from '../../../../helper/common';
import { getBookings, putFinishMatching, updateStatusMatching } from '../../../../redux/services/customerSlice';

import ModalSuccess from '../../../../components/modalSuccess/modalSuccess';
import HelmetComp from '../../../../components/helmet/Helmet';
import image from '../../../../assets/images/index';
import config from '../../../../config';

const FEE_EXTEND_ASSIGN: string = '7,700';
const FEE_EXTEND_NOT_ASSIGN: string = '6,600';

export default function CustomerBooking({ isEdit = false }) {
  const { Panel }: any = Collapse;
  const dispatch: Dispatch<any> = useDispatch();
  const navigate: NavigateFunction = useNavigate();
  const [api, showPopup]: any = notification.useNotification();

  const [isLate, setIsLate]: any = useState<boolean>(false);
  const [idBookingMatchDelete, setIdBookingMatchDelete]: any = useState<number>();
  const [idBookingMatchUpdate, setIdBookingMatchUpdate]: any = useState<number>();
  const [typeModal, setTypeModal]: [any, React.Dispatch<any>] = useState<string>();
  const [timeManage, setTimeManage]: any = useState<any>([]);

  const { listBooking, currentTime } = useSelector((state: any) => state.customerReducer);

  // TEST Timeout
  useEffect((): void => {
    dispatch(getBookings());
  }, []);

  useEffect((): void => {
    if (listBooking?.length !== 0) {
      setTimeManage(
        listBooking?.map((booking: any): any => {
          return {
            id: booking?.id ?? booking?.customer_service_id,
            date: booking?.date,
            date_time: currentTime?.split(':'),
            date_hour: currentTime?.split(':'),
            end_time: booking?.end_time,
            start_time: booking?.start_time,
            status: booking?.status,
            status_matching: booking?.status_matching,
            is_extend: booking?.is_extend,
          };
        }),
      );
    }
  }, [listBooking]);

  useEffect(() => {
    if (timeManage?.length > 0) {
      let timeName = timeManage?.map((timeItem: any): any => {
        return {
          timeName: timeItem?.id,
        };
      });

      let current_time: any = '';

      if (currentTime !== '') {
        const convertTime = currentTime?.split(' ');
        const date_time = convertTime[0];
        const date_hour = convertTime[1]?.split(':');

        //   Fake time
        current_time = new Date(date_time).setHours(+date_hour[0], +date_hour[1], +date_hour[2], 999);
      }

      for (let i: number = 0; i < timeManage?.length; i++) {
        // HANDLE TIME
        const beforeOneDay: number = addDays(new Date(timeManage[i]?.date), -1).setHours(18, 59, 59, 999); // 19:00 THE DAY BEFORE
        const findStartHour: any = hourArrayItemsForBooking.find((hour: any) => hour?.id === timeManage[i]?.start_time); //FIND START HOUR
        const findEndHour: any = hourArrayItemsForBooking.find((hour: any) => hour?.id === timeManage[i]?.end_time); // FIND END HOUR
        const timeStart: number = new Date(timeManage[i]?.date).setHours(findStartHour?.hour, 0, 0, 0); // TIME BOOKING START
        const tenMinutesBeforeEndTime: number = new Date(timeManage[i]?.date).setHours(findEndHour?.hour, 50, 0, 0); // 10 MINUTES BEFORE CLOSING TIME
        const timeEnd: number = new Date(timeManage[i]?.date).setHours(findEndHour?.hour + 1, 0, 0, 0); // CLOSING TIME
        const fifteenMinutesAfterEndTime: number = new Date(timeManage[i]?.date).setHours(
          findEndHour?.hour + 1,
          15,
          0,
          0,
        ); //15 MINUTES AFTER CLOSING TIME
        const endHourExtend: number = new Date(timeManage[i]?.date).setHours(findEndHour.hour + 2, 0, 0, 0); // 1 HOUR AFTER END TIME

        const endHourExtendAddOneHour: number = new Date(timeManage[i]?.date).setHours(findEndHour.hour + 3, 0, 0, 0); // 1 HOUR AFTER END TIME

        // STATUS 1 :  19:00 THE DAY BEFORE
        if (current_time < beforeOneDay && beforeOneDay - current_time < 1000000000) {
          if (timeManage[i]?.status === 1) {
            const timerId: NodeJS.Timeout = setTimeout((): void => {
              const handleUpdateStatus = async (): Promise<void> => {
                await dispatch(
                  updateStatusMatching({
                    id: timeManage[i]?.id,
                    body: {
                      status: 2,
                    },
                  }),
                );
              };

              handleUpdateStatus();
            }, beforeOneDay - current_time);

            timeName[i] = {
              ...timeName[i],
              name: timerId,
            };
          }
        }

        // STATUS 2 : TIME BOOKING START
        if (current_time < timeStart && current_time > beforeOneDay && timeManage[i]?.status_matching !== 0) {
          if (timeManage[i]?.status === 2) {
            const timerId: NodeJS.Timeout = setTimeout((): void => {
              const handleUpdateStatus = async (): Promise<void> => {
                await dispatch(
                  updateStatusMatching({
                    id: timeManage[i]?.id,
                    body: {
                      status: 3,
                    },
                  }),
                );
              };

              handleUpdateStatus();
            }, timeStart - current_time);

            timeName[i] = {
              ...timeName[i],
              name: timerId,
            };
          }
          if (timeManage[i]?.status !== 2 && timeManage[i]?.status !== 3) {
            const handleUpdateStatus = async (): Promise<void> => {
              await dispatch(
                updateStatusMatching({
                  id: timeManage[i]?.id,
                  body: {
                    status: 2,
                  },
                }),
              );
            };

            handleUpdateStatus();
          }
        }

        // STATUS 3 : 10 MINUTES BEFORE CLOSING TIME
        if (
          current_time < tenMinutesBeforeEndTime &&
          current_time > timeStart &&
          timeManage[i]?.status_matching !== 0
        ) {
          if (timeManage[i]?.status === 3) {
            const timerId: NodeJS.Timeout = setTimeout((): void => {
              const handleUpdateStatus = async (): Promise<void> => {
                await dispatch(
                  updateStatusMatching({
                    id: timeManage[i]?.id,
                    body: {
                      status: 4,
                    },
                  }),
                );
              };

              handleUpdateStatus();
            }, tenMinutesBeforeEndTime - current_time);

            timeName[i] = {
              ...timeName[i],
              name: timerId,
            };
          }
          if (timeManage[i]?.status !== 3 && timeManage[i]?.status !== 4) {
            const handleUpdateStatus = async (): Promise<void> => {
              await dispatch(
                updateStatusMatching({
                  id: timeManage[i]?.id,
                  body: {
                    status: 3,
                  },
                }),
              );
            };
            handleUpdateStatus();
          }
        }

        // STATUS 4 : CLOSING TIME
        if (
          current_time < timeEnd &&
          current_time > tenMinutesBeforeEndTime &&
          timeManage[i]?.status_matching !== 0 &&
          timeManage[i]?.is_extend !== 1
        ) {
          if (timeManage[i]?.status === 4 && timeManage[i]?.is_extend !== 1) {
            const timerId: NodeJS.Timeout = setTimeout((): void => {
              const handleUpdateStatus = async (): Promise<void> => {
                await dispatch(
                  updateStatusMatching({
                    id: timeManage[i]?.id,
                    body: {
                      status: 5,
                    },
                  }),
                );
              };

              handleUpdateStatus();
            }, timeEnd - current_time);

            timeName[i] = {
              ...timeName[i],
              name: timerId,
            };
          }
          if (timeManage[i]?.status !== 4 && timeManage[i]?.status !== 5 && timeManage[i]?.is_extend !== 1) {
            const handleUpdateStatus = async (): Promise<void> => {
              await dispatch(
                updateStatusMatching({
                  id: timeManage[i]?.id,
                  body: {
                    status: 4,
                  },
                }),
              );
            };

            handleUpdateStatus();
          }
        }

        // STATUS 5 : 15 MINUTES AFTER CLOSING TIME
        if (
          current_time < fifteenMinutesAfterEndTime &&
          current_time > timeEnd &&
          timeManage[i]?.status_matching !== 0 &&
          timeManage[i]?.is_extend !== 1
        ) {
          if (timeManage[i]?.status === 5) {
            const timerId: NodeJS.Timeout = setTimeout((): void => {
              const handleUpdateStatus = async (): Promise<void> => {
                await dispatch(
                  updateStatusMatching({
                    id: timeManage[i]?.id,
                    body: {
                      status: 6,
                    },
                  }),
                );
              };

              handleUpdateStatus();
            }, fifteenMinutesAfterEndTime - current_time);

            timeName[i] = {
              ...timeName[i],
              name: timerId,
            };
          }
          if (timeManage[i]?.status !== 5 && timeManage[i]?.status !== 6) {
            const handleUpdateStatus = async (): Promise<void> => {
              await dispatch(
                updateStatusMatching({
                  id: timeManage[i]?.id,
                  body: {
                    status: 5,
                  },
                }),
              );
            };

            handleUpdateStatus();
          }
        }

        //   HANDLE STATUS 7: EXTENDED
        if (
          current_time < endHourExtend &&
          current_time > fifteenMinutesAfterEndTime &&
          timeManage[i]?.status_matching !== 0
        ) {
          if (timeManage[i]?.status === 7) {
            const timerId: NodeJS.Timeout = setTimeout((): void => {
              const handleUpdateStatus = async (): Promise<void> => {
                await dispatch(
                  updateStatusMatching({
                    id: timeManage[i]?.id,
                    body: {
                      status: 6,
                    },
                  }),
                );
              };

              handleUpdateStatus();
            }, endHourExtend - current_time);

            timeName[i] = {
              ...timeName[i],
              name: timerId,
            };
          }

          if (timeManage[i]?.status !== 6 && timeManage[i]?.status !== 7) {
            const handleUpdateStatus = async (): Promise<void> => {
              await dispatch(
                updateStatusMatching({
                  id: timeManage[i]?.id,
                  body: {
                    status: 6,
                  },
                }),
              );
            };

            handleUpdateStatus();
          }
        }

        if (
          current_time > endHourExtend &&
          timeManage[i]?.status_matching !== 0 &&
          current_time < endHourExtendAddOneHour
        ) {
          if (timeManage[i]?.status === 7) {
            const timerId: NodeJS.Timeout = setTimeout((): void => {
              const handleUpdateStatus = async (): Promise<void> => {
                await dispatch(
                  updateStatusMatching({
                    id: timeManage[i]?.id,
                    body: {
                      status: 6,
                    },
                  }),
                );
              };

              handleUpdateStatus();
            }, endHourExtend - current_time);

            timeName[i] = {
              ...timeName[i],
              name: timerId,
            };
          }
        }
      }

      return (): void => {
        const findTimeEnd = timeManage?.find((time: any) => time?.active);
        const findTimeNameEnd = timeName?.find((itemTimeName: any): boolean => itemTimeName?.id === findTimeEnd?.id);
        clearTimeout(findTimeNameEnd?.name);
      };
    }
  }, [timeManage]);

  const handleClickCancel = (item: any): void => {
    let dateCurrent: Date = new Date();
    setIdBookingMatchDelete(item?.id);
    let beforeDay: Date = new Date(addDays(new Date(item?.date), -1).setHours(18, 59, 59, 999));
    if (dateCurrent > beforeDay) {
      setTypeModal('delete_booking');
      setIsLate(true);
    }
    if (dateCurrent < beforeDay) {
      navigate(`/user/mypage/reserve/select/${item?.id}/cancel`);
    }
  };
  const handleClickChange = (item: any): void => {
    let dateCurrent: Date = new Date();
    let beforeDay: Date = new Date(addDays(new Date(item?.date), -1).setHours(18, 59, 59, 999));
    if (dateCurrent < beforeDay) {
      navigate(`${config.routes.customerChangeBooking}/${item?.id}`);
    }
  };
  const handleClickExtend = (item: any): void => {
    setTypeModal('update_booking');
    setIsLate(true);
    setIdBookingMatchUpdate(item?.id);
  };

  //Handle finish job
  const handleFinishJob = async (item: any): Promise<void> => {
    const matchingReverseData: any = {
      date: item?.dateStringWithoutTime,
      name: item?.cast_name_assign ? item?.cast_name_assign : item?.cast_name_not_assign,
    };
    setLocalStorage('mrsdt', matchingReverseData);
    const res = await dispatch(putFinishMatching(item?.id));
    if (res?.payload?.status === 'success') {
      alertSuccess(api, '変更が完了しました。');
      navigate(`${config.routes.customerSurvey}/${item?.id}`);
    } else {
      alertFail(api, '変更に失敗しました。');
    }
  };

  return (
    <div className="customer-booking container-680">
      <HelmetComp user title={title.customerBooking} />
      {showPopup}
      <ModalSuccess
        cast
        type={typeModal}
        showChangeWarning={isLate}
        setShowChangeWarning={setIsLate}
        idBookingMatchDelete={idBookingMatchDelete}
        idBookingMatchUpdate={idBookingMatchUpdate}
      />
      <div className="title">
        <img src={image.infoIcon} alt="" />
        <h1>予約内容詳細</h1>
      </div>
      <div className="list-services">
        <Collapse
          bordered={false}
          expandIcon={({ isActive }: any): any => (!isActive ? <PlusOutlined /> : <MinusOutlined />)}
          expandIconPosition={'end'}
        >
          {listBooking?.map((item: any) => {
            return (
              <Panel
                header={
                  <div>
                    <p className="booking-date">{item.dateString}</p>
                    <p className="booking-status">
                      依頼ステータス :
                      <span
                        style={
                          item?.cancelled_at
                            ? {
                              color: '#C30D23',
                            }
                            : item?.status_matching === 1
                              ? {
                                color: '#2EA7E0',
                              }
                              : {}
                        }
                      >
                        {item?.cancelled_at ? 'キャンセル' : item?.status_matching === 0 ? ' 予約未確定' : ' 予約確定'}
                      </span>
                    </p>
                  </div>
                }
                key={item.id}
              >
                <div className={`service-detail ${item?.cancelled_at ? 'service-cancelled' : ''}`}>
                  <div className="service-detail-element">
                    <span className="field">予約日時</span>
                    <span className="value">{item?.dateString !== undefined ? item?.dateStringWithTime : ''}</span>
                  </div>
                  <div className="service-detail-element">
                    <span className="field">依頼時間 </span>
                    <span className="value">
                      {item?.hour !== undefined ? hourScheduleItems[item?.hour - 2]?.title : ''}
                    </span>
                  </div>
                  {item?.is_assign !== undefined ? (
                    <div className="service-detail-element">
                      <span className={`field ${item?.cancelled_at ? 'item-cancelled' : ''}`}>
                        {item?.cancelled_at ? 'キャスト' : 'キャスト氏名'}
                      </span>
                      <span
                        className={`value ${item?.cancelled_at ? 'item-cancelled' : ''}`}
                        style={item?.cancelled_at ? { color: '#C30D23' } : {}}
                      >
                        {item?.cancelled_at ? (
                          <>
                            申し訳ございません <br /> 日時の合うキャストがいない為 <br />
                            サービスはキャンセルされました。
                          </>
                        ) : (
                          item?.assign_text
                        )}
                      </span>
                    </div>
                  ) : (
                    ''
                  )}
                  {item?.is_extend === 1 ? (
                    <div className="service-detail-element">
                      <span className="field">延長料金</span>
                      <span className="value">{`¥${item?.is_assign === 1 ? FEE_EXTEND_ASSIGN : FEE_EXTEND_NOT_ASSIGN
                        }`}</span>
                    </div>
                  ) : (
                    ''
                  )}
                  <div className="service-detail-element">
                    <span className="field">概算料金</span>
                    <span className="value" style={item?.cancelled_at ? { color: '#C9CACA' } : {}}>{`¥${item?.cancelled_at ? '00,000' : ` ${convertMoney(item?.price?.toString())}(税込) ` ?? '0'
                      }`}</span>
                  </div>
                  {item?.cancelled_at ? (
                    ''
                  ) : (
                    <>
                      {item?.status === 1 && (
                        <div className={'btn-extend'}>
                          <Button
                            type="primary"
                            className="change"
                            onClick={(): void => {
                              handleClickChange(item);
                            }}
                          >
                            日時変更
                          </Button>
                          <Button type="primary" className="cancel" onClick={(): void => handleClickCancel(item)}>
                            キャンセル
                          </Button>
                          <Button type="primary" className="add-hour" disabled={true}>
                            <img src={image.iconPlusExtend} alt="Error" />
                            1時間延長
                          </Button>
                        </div>
                      )}
                      {item?.status === 2 && (
                        <div>
                          <div className={'btn-extend secondary'}>
                            <Button type="primary" className="cancel" onClick={(): void => handleClickCancel(item)}>
                              キャンセル
                            </Button>
                            <Button
                              type="primary"
                              className="add-hour"
                              onClick={() => handleClickExtend(item)}
                              disabled={true}
                            >
                              <img src={image.iconPlusExtend} alt="Error" />
                              1時間延長
                            </Button>
                          </div>
                        </div>
                      )}
                      {item?.status === 3 && (
                        <div className="btn-extend secondary">
                          <Button type="primary" disabled={true} className="btn-finish">
                            作業完了
                          </Button>
                          <Button
                            type="primary"
                            className="add-hour"
                            onClick={() => handleClickExtend(item)}
                            disabled={true}
                          >
                            <img src={image.iconPlusExtend} alt="Error" />
                            1時間延長
                          </Button>
                        </div>
                      )}
                      {item?.status === 4 && (
                        <div className="btn-extend secondary">
                          <Button type="primary" disabled={true} className="btn-finish">
                            作業完了
                          </Button>
                          {item?.is_extend === 0 ? (
                            <Button type="primary" className="add-hour active" onClick={() => handleClickExtend(item)}>
                              <img src={image.iconPlusExtend} alt="Error" />
                              1時間延長
                            </Button>
                          ) : (
                            <></>
                          )}
                        </div>
                      )}
                      {item?.status === 5 && (
                        <div className="btn-extend secondary">
                          <Button type="primary" className="btn-finish active" onClick={() => handleFinishJob(item)}>
                            作業完了
                          </Button>
                          {item?.is_extend === 0 ? (
                            <Button type="primary" className="add-hour active" onClick={() => handleClickExtend(item)}>
                              <img src={image.iconPlusExtend} alt="Error" />
                              1時間延長
                            </Button>
                          ) : (
                            <></>
                          )}
                        </div>
                      )}
                      {item?.status === 6 && (
                        <div className="btn-extend secondary">
                          <Button type="primary" className="btn-finish active" onClick={() => handleFinishJob(item)}>
                            作業完了
                          </Button>
                        </div>
                      )}
                      {item?.status === 7 && (
                        <div className="btn-extend secondary">
                          <Button
                            type="primary"
                            className="btn-finish"
                            onClick={() => handleFinishJob(item)}
                            disabled={true}
                          >
                            作業完了
                          </Button>
                        </div>
                      )}
                    </>
                  )}
                </div>
              </Panel>
            );
          })}
          <div className="note">
            <span className="note-item">※ 日時変更・キャンセルは詳細より選択いただけます。</span>
            <span className="note-item">※ 最新の10件を表示</span>
          </div>
        </Collapse>
      </div>
      <span className="instruct">
        キャンセル及び変更に関する注意点は
        <a href="https://www.epais.co.jp/tos/#tos04" target="_blank" rel="noopener noreferrer">
          コチラ
        </a>
      </span>
      <div className="extensions">
        <div className="extensions-title">
          <img src={image.iconHourglass} alt="" />
          <span>延長について</span>
        </div>
        <p className="extensions-content">
          サービス終了時刻＋15分までに延長を行ってください。
          <br /> 終了時刻＋15分後には延長はできなくなります。
        </p>
      </div>
      <div className="btn-reserve-block">
        <Button
          className="btn"
          onClick={(): void => {
            navigate(config.routes.customerDashboard);
          }}
        >
          戻る
        </Button>
      </div>
    </div>
  );
}
